import { Unknown } from '../constants/currency-codes';

const LEFT = 'left';
const RIGHT = 'right';

const defaultCurrencyCodeToSymbolMap = {
  USD: {
    symbol: '$',
    placement: LEFT,
  },
  CAD: {
    symbol: 'CA$',
    placement: LEFT,
  },
  GBP: {
    symbol: '£',
    placement: LEFT,
  },
  EUR: {
    symbol: '€',
    placement: RIGHT,
  },
  AUD: {
    symbol: 'A$',
    placement: LEFT,
  },
  NZD: {
    symbol: 'NZ$',
    placement: LEFT,
  },
};

const GetCurrencySymbolFromIntlApi = (currencyCode, currentLocale) => {
  if (!currencyCode || currencyCode === Unknown) {
    return '';
  }

  const currencyParts = new Intl.NumberFormat(currentLocale, {
    style: 'currency',
    currency: currencyCode,
  }).formatToParts(0);

  if (currencyParts[0].type === 'currency') {
    return {
      symbol: currencyParts[0].value,
      placement: LEFT,
    };
  }
  if (currencyParts[currencyParts.length - 1].type === 'currency') {
    return {
      symbol: currencyParts[currencyParts.length - 1].value,
      placement: RIGHT,
    };
  }
  const currencyPart = currencyParts.find((part) => part.type === 'currency');

  if (currencyPart) {
    return {
      symbol: currencyPart.value,
      placement: undefined,
    };
  }
  return undefined;
};

const GetCurrencySymbolFromDefaults = (currencyCode) => {
  if (!currencyCode) {
    return { symbol: '', placement: LEFT };
  }

  return defaultCurrencyCodeToSymbolMap[currencyCode];
};

class CurrencyServiceClass {
  getSymbolFromCode(code, defaultCurrencyCode = '', currentLocale = '') {
    return (
      GetCurrencySymbolFromIntlApi(code, currentLocale) ||
      GetCurrencySymbolFromDefaults(code, currentLocale) ||
      GetCurrencySymbolFromIntlApi(defaultCurrencyCode, currentLocale) ||
      GetCurrencySymbolFromDefaults(defaultCurrencyCode, currentLocale) ||
      ''
    );
  }

  floorCurrency(value) {
    if (value === null || value === undefined || Number.isNaN(value)) {
      return Number.NaN;
    }
    const normalized = Number.parseFloat(value.toPrecision(15));
    return Math.floor(normalized * 100) / 100;
  }
}

export const CurrencyService = new CurrencyServiceClass();
